import { render, staticRenderFns } from "./WorkflowProcess.vue?vue&type=template&id=229503a0&"
import script from "./WorkflowProcess.vue?vue&type=script&lang=js&"
export * from "./WorkflowProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports